import { graphql } from "gatsby"
import * as React from "react"
import { Base, Logo, Text } from "./ui"
import * as styles from "./ui.css"
import ReactHtmlParser from 'react-html-parser'

export function LogoItem(props) {
  if (!props.image) return null

  return (
    <Logo alt={props.alt} image={props.image.gatsbyImageData} size='medium' />
  )
}

export default function LogoList(props) {
  let wrapperSection = [styles.logoListSection];
  const awards = props.name === 'Reconhecida por';
  if (awards) {
    wrapperSection.push(styles.logoListSectionAwards);
  }
  return (
    <Base as='div' cx={wrapperSection}>
      <div style={{ display: 'flex', flexDirection: 'column', marginTop: ( awards ? 0 : 57), marginBottom: 40}}>
          <Text center variant="logolead" style={{margin: 0, ...(awards ? {color: '#0078B2'} : {})}}>
            {ReactHtmlParser(props.text)}
          </Text>
      </div>
      <Base as="div" style={{width: '100%', overflow: 'hidden'}}>
        <Base as="div" cx={[styles.logoImagesWrapper]} gap={0}>
          {[0,1,2,3].map(() => props.logos.map(
            (logo) =>
              logo && (
                <Base as='div' key={'logo_id_'+logo.id} cx={[awards ? styles.logoImageLiAward : styles.logoImageLi ]}>
                  <LogoItem {...logo} />
                </Base>
              )
          ))}
        </Base>
      </Base>
    </Base>
  )
}

export const query = graphql`
  fragment HomepageLogoListContent on HomepageLogoList {
    id
    name
    text
    logos {
      id
      alt
      image {
        id
        gatsbyImageData
        alt
      }
    }
  }
`
